import { usePlanningStore } from '@planning/AppProvider'
import { useTranslate } from '@tolgee/react'
import { useCallback } from 'react'
import { useOrderListUploadMessagesHandler } from '../../VesselVisit/Components/Upload/hooks/useOrderListUploadMessagesHandler'
import { CSVUploadAlertReason, ICSVUploadAlertParams } from '../stores/CSVUploadViewStore'

export const useCSVUploadAlerts = () => {
  const { t } = useTranslate()
  const { appViewStore } = usePlanningStore()
  const { getExceptionMessage } = useOrderListUploadMessagesHandler()

  const handleCSVUploadAlert = useCallback(
    ({ reason, type, message, data }: ICSVUploadAlertParams) => {
      switch (reason) {
        case CSVUploadAlertReason.ParserError:
          appViewStore.setShowAlert(type, t('parserError', 'Error parsing file.'))
          break
        case CSVUploadAlertReason.UploadSuccess:
          appViewStore.setShowAlert(
            'success',
            t('fileUploadedSuccessfully', 'File uploaded successfully'),
          )
          break
        case CSVUploadAlertReason.GenericError:
          appViewStore.setShowAlert(type, message || getExceptionMessage(data))
          break
        case CSVUploadAlertReason.YardValidationError:
          const yardErrors = (data as { key: string; params: any }[]) || []
          const yardErrorMappers: Record<string, (params: any) => string> = {
            blockNotFound: p => t('blockNotFound', 'Block "{block}" not found.', p),
            bayNotFound: p => t('bayNotFound', 'Bay "{bay}" not found in block "{block}".', p),
            rowNotFound: p => t('rowNotFound', 'Row "{row}" not found in block "{block}".', p),
            invalidTier: p =>
              t(
                'invalidTier',
                'Tier "{tier}" is invalid for block "{block}" (Max tier: {maxTiers}).',
                p,
              ),
          }

          const yardMessage = yardErrors
            .map(err => yardErrorMappers[err.key]?.(err.params))
            .filter(Boolean)
            .join(' ')
          appViewStore.setShowAlert(type, yardMessage)
          break
        case CSVUploadAlertReason.ContainersOnTerminalError:
          appViewStore.setShowAlert(
            type,
            t(
              'containersAlreadyOnTerminal',
              'The following containers are already on the terminal: {containers}.',
              { containers: message },
            ),
          )
          break
      }
    },
    [appViewStore, getExceptionMessage, t],
  )

  return { handleCSVUploadAlert }
}
